






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class FootbowlText extends Vue {

  get contentKey() {
    return `${this.uniqueIdentifier}_${this.internalKey}`;
  }

  @Prop({ required: true, type: String })
  public prop!: string;
  private internalKey = 0;
  private uniqueIdentifier = Math.random() * 1e7;
  private unwatch!: () => void;

  public created() {
    this.unwatch = this.$parent.$watch(this.prop, () => {
      this.internalKey++;
    });
  }

  public beforeDestroy() {
    this.unwatch();
  }

  public onContentChange() {
    this.internalKey++;
  }
}
